import { post } from "shared/data";
import { useCallback } from "react";

export const useLastOpenedTask = () => {
    return useCallback((taskId) => post(`/tasking/tasks/lastopened/${taskId}`), []);
};
